export enum BillingStatus {
  "Trial" = "TRIAL",
  "TrialExpired" = "TRIAL_EXPIRED",
  "RequestedPaid" = "REQUESTED_PAID",
  "Paid" = "PAID",
  "FreeUnlimited" = "FREE_UNLIMITED"
}
